import React, { Component } from "react";
import { connect } from "react-redux";
import {
  Field,
  reduxForm,
  stopSubmit,
  getFormValues,
  FieldArray,
} from "redux-form";
import {
  Form,
  FormGroup,
  Label,
  Alert,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Modal,
  ModalBody,
} from "reactstrap";

import TextInput from "../../system/fields/TextInput";
import SelectDropdown from "../../system/fields/SelectDropdown";
import FileUpload from "../../system/fields/FileUpload";
import AddressSearch from "../../system/fields/AddressSearch";
import Wysiwyg from "../../system/fields/Wysiwyg";
import List from "../../system/fields/List";

import DealNewCountryWrapper from "../Deals/components/DealNewCountryWrapper";

import * as validations from "../../system/utils/Validation";

import { getOverview } from "../../store/overview";
import ReviewsTable from "../Deals/components/ReviewsTable";
import Activites from "./components/Activites";
import Faq from "./components/Faq";

class EditForm extends Component {
  constructor() {
    super();

    this.toggleCountry = this.toggleCountry.bind(this);
  }
  state = {
    activeTab: 1,
    countryToggle: false,
  };

  toggleCountry() {
    this.setState({
      countryToggle: !this.state.countryToggle,
    });
  }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  componentDidMount() {
    this.props.dispatch(getOverview());
  }

  render() {
    const { handleSubmit, mode, regions } = this.props;

    return (
      <section className="edit-form">
        <Form onSubmit={handleSubmit}>
          <Nav tabs>
            <NavItem>
              <NavLink
                className={this.state.activeTab === 1 ? "active" : ""}
                onClick={() => this.toggleTab(1)}
              >
                City Details
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={this.state.activeTab === 3 ? "active" : ""}
                onClick={() => this.toggleTab(3)}
              >
                Destination Guide
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={this.state.activeTab === 4 ? "active" : ""}
                onClick={() => {
                  this.toggleTab(4);
                }}
              >
                Reviews
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={this.state.activeTab === 5 ? "active" : ""}
                onClick={() => {
                  this.toggleTab(5);
                }}
              >
                Activities
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={this.state.activeTab === 6 ? "active" : ""}
                onClick={() => {
                  this.toggleTab(6);
                }}
              >
                F&Q's
              </NavLink>
            </NavItem>
          </Nav>
          <section className="form-section">
            <TabContent activeTab={this.state.activeTab}>
              <TabPane tabId={1}>
                <div className="row">
                  <FormGroup className="col-12 col-sm-6">
                    <Label htmlFor="email">City Name</Label>
                    <Field
                        name="name"
                        placeholder="Enter City Name"
                        component={AddressSearch}
                        type="text"
                        validate={validations.required}
                    />
                  </FormGroup>

                  <FormGroup className="col-12 col-sm-6">
                    <Label>Country Name</Label>
                    <Field
                        name="countries"
                        component={SelectDropdown}
                        options={this.props.countries}
                        labelKey={"value"}
                        valueKey={"id"}
                        type="text"
                        multi={false}
                        className="form-control"
                        validate={validations.required}
                    />
                    <a href="#" role="button" onClick={this.toggleCountry}>
                      Add Country
                    </a>
                    <Modal
                        isOpen={this.state.countryToggle}
                        toggle={this.toggleCountry}
                    >
                      <ModalBody>
                        <DealNewCountryWrapper regions={regions}/>
                      </ModalBody>
                    </Modal>
                  </FormGroup>
                </div>
                <div className={"row"}>
                  <FormGroup className={"col-12 col-sm-6"}>
                    <Label>Youtube url</Label>
                    <Field name={"video"} component={TextInput} type={"text"}/>
                  </FormGroup>
                </div>
                <div className="row">
                  <FormGroup className="col-12">
                    <Label>Sub Heading</Label>
                    <Field
                        name="subtitle"
                        placeholder="Sub Heading"
                        component={TextInput}
                        type="text"
                    />
                  </FormGroup>
                </div>
                <div className="row">
                  <FormGroup className="col-12">
                    <Label>Hero Image</Label>
                    <p className="instruction">
                      Images must be 1920 x 1080 or bigger in the same aspect
                      ratio
                    </p>
                    <Field
                        name="banner_image"
                        component={FileUpload}
                        multiple={false}
                        files={false}
                        images={true}
                        type="text"
                        className="form-control"
                        validate={validations.required}
                    />
                  </FormGroup>
                </div>

                <div className="row">
                  <FormGroup className="col-12">
                    <Label>Top Description (Summary)</Label>
                    <Field
                        name="summary"
                        component={Wysiwyg}
                        placeholder="Summary"
                        className="form-control"
                        type="text"
                        validate={validations.required}
                    />
                  </FormGroup>
                </div>

                <div className="row">
                  <FormGroup className="col-12">
                    <Label>Top Description Multi Centre (Summary)</Label>
                    <Field
                        name="multi_center_summary"
                        component={Wysiwyg}
                        placeholder="Summary"
                        className="form-control"
                        type="text"
                    />
                  </FormGroup>
                </div>

                <div className="row">
                  <FormGroup className="col-12">
                    <Label>Top Description Guided Tour (Summary)</Label>
                    <Field
                        name="guided_tour_summary"
                        component={Wysiwyg}
                        placeholder="Summary"
                        className="form-control"
                        type="text"
                    />
                  </FormGroup>
                </div>

                <div className="row">
                  <FormGroup className="col-12">
                    <Label>Description</Label>
                    <Field
                        name="description"
                        component={Wysiwyg}
                        placeholder="Summary"
                        className="form-control"
                        type="text"
                    />
                  </FormGroup>
                </div>

                <div className="row">
                  <FormGroup className="col-12">
                    <Label>Description Multi Centre</Label>
                    <Field
                        name="multi_center_description"
                        component={Wysiwyg}
                        placeholder="Summary"
                        className="form-control"
                        type="text"
                    />
                  </FormGroup>
                </div>

                <div className="row">
                  <FormGroup className="col-12">
                    <Label>Description Guided Tour</Label>
                    <Field
                        name="guided_tour_description"
                        component={Wysiwyg}
                        placeholder="Summary"
                        className="form-control"
                        type="text"
                    />
                  </FormGroup>
                </div>

                <div className="row">
                  <FormGroup className="col-12 col-sm-4"/>
                </div>
              </TabPane>
              <TabPane tabId={2}>
                <div className="row">
                  <FormGroup className="col-12 col-sm-6">
                    <Label htmlFor="email">Reorder Deals</Label>
                    <Field
                        name="deals"
                        component={List}
                        type="text"
                        itemsDisabled={true}
                    />
                  </FormGroup>
                </div>
              </TabPane>
              <TabPane tabId={3}>
                <div className="row">
                  <FormGroup className="col-12">
                    <Label>Guide</Label>
                    <Field name="guide" component={Wysiwyg} type="text" />
                  </FormGroup>
                </div>
              </TabPane>
              <TabPane tabId={4}>
                <ReviewsTable
                  data={this.props.reviews}
                  dispatch={this.props.dispatch}
                  formValues={this.props.formValues}
                  initialValues={this.props.initialValues}
                  formType="CityForm"
                />
              </TabPane>
              <TabPane tabId={5}>
                <FieldArray name={"activities"} component={Activites} />
              </TabPane>
              <TabPane tabId={6}>
                <FieldArray name={"faqs"} component={Faq} />
              </TabPane>
            </TabContent>
          </section>
        </Form>

        {this.props.submitFailed && (
          <div className="error-container">
            <Alert color="danger">
              <strong>There are errors in your form.</strong>
              <br />
              Please check before submitting again.
            </Alert>
          </div>
        )}
      </section>
    );
  }
}

EditForm = reduxForm({
  form: "CityForm",
  onChange: (values, dispatch, props) => {
    if (props.error || props.submitFailed) {
      dispatch(stopSubmit("CityForm"));
    }
  },
  destroyOnUnmount: false,
})(EditForm);

const mapStateToProps = (state) => {
  return {
    cities: state.overview.cities,
    reviews: state.overview.reviews,
    formValues: getFormValues("CityForm")(state),
  };
};

export default connect(mapStateToProps)(EditForm);



// WEBPACK FOOTER //
// ./src/containers/City/Form.jsx